export default {
  text: {
    order_cancelled: 'Ordre annulleret – ingen chauffør tilgængelig',
    wolt_support: 'Spørgsmål? Ring direkte til Wolt <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>HASTER:</strong> Accepter eller afvis denne ordre med det samme',
  },
  labels: {
    dummy_order: 'Testordre',
    items_one: '{{count}} vare',
    items_other: '{{count}} varer',
    needs_acceptance: 'Kræver accept',
    driver_pending: 'Venter på chauffør',
    today: 'I dag',
    driver_assigned: 'Chauffør tildelt',
    complete: 'Fuldført',
  },
  buttons: {
    complete_order: 'Markér som fuldført',
    looking_for_driver: 'Leder efter en chauffør...',
    click_to_remove: 'Klik for at fjerne',
  },
};
